import React from 'react';
import { AppNextLink } from '@/features/app-next-link';
import { LinkCollection } from './type';
interface Props {
  collection: LinkCollection['collection'];
}
export default function ColumnsLinks({
  collection
}: Props) {
  return <div className='flex flex-col gap-4.5 lg:gap-3 lg:pr-2' data-sentry-component="ColumnsLinks" data-sentry-source-file="columns-links.tsx">
            {collection.map(child => <AppNextLink href={child.url} key={child.url} prefetch={false} className='w-fit border-transparent text-xs font-medium text-white hover:border-brand-secondary hover:text-brand-secondary lg:border-b lg:pb-1 lg:text-sm'>
                    {child.title}
                </AppNextLink>)}
        </div>;
}